import '.a{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.a7{box-shadow:0px 0px 15px 0px rgba(0, 0, 0, 0.15);}.ssr-plugin'
import '.a8{border-radius:1.25rem;}.ssr-plugin'
import '.a9{background-color:var(--shades-white);}.ssr-plugin'
import '.aa{overflow:hidden;}.ssr-plugin'
import '.cf{padding:1rem 1.5rem;}.ssr-plugin'
import '.cg{background:var(--shades-white);}.ssr-plugin'
import '.a2{justify-content:space-between;}.ssr-plugin'
import '.f{align-items:center;}.ssr-plugin'
import '.ch{align-self:center;}.ssr-plugin'
import '.bu{padding:1.5rem;}.ssr-plugin'
import '.i{gap:1.5rem;}.ssr-plugin'
import '.k{display:grid;}.ssr-plugin'
import '.b{justify-content:center;}.ssr-plugin'
import '.a1{width:100%;}.ssr-plugin'
import '.ci{gap:0.75rem;}.ssr-plugin'
import '.bo{padding:1rem;}.ssr-plugin'
import '.bx{background-color:var(--shades-blue-50);}.ssr-plugin'
import '.b4{border:none;}.ssr-plugin'
import '.cj{border-radius:1rem;}.ssr-plugin'
import '.al{cursor:pointer;}.ssr-plugin'
import '.ck{transition:background-color 0.2s ease;}.ssr-plugin'
import '.cl{width:1rem;}.ssr-plugin'
import '.cm{height:1rem;}.ssr-plugin'
import '.au{color:var(--primary-blue);}.ssr-plugin'
import '.cn{font-size:1.15rem;}.ssr-plugin'
import '.aw{font-weight:400;}.ssr-plugin'
import '.co{justify-content:flex-end;}.ssr-plugin'
import { styled } from 'inlines'
import { useState } from 'react'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { Title } from '@app/components/core/typography/Title'
import useMediaQuery from '@app/util/useMediaQuery'
import { useTranslations } from '@i18n/useLanguage'
import { ModalWrapper } from './ModalWrapper'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faLink } from '@fortawesome/pro-regular-svg-icons'
import { faXTwitter, faFacebook, faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import { SocialMediaButton } from './SocialMediaButton'

export type SocialShareModalProps = {
  isOpen: boolean
  onClose: () => void
  url?: string
  title?: string
  renderContainer?: HTMLElement
}

export const SocialShareModal = ({
  isOpen,
  onClose,
  url: urlProp,
  title: titleProp,
  renderContainer,
}: SocialShareModalProps) => {
  const translations = useTranslations().app.socialShareModal
  const isMobile = useMediaQuery()
  const [copySuccess, setCopySuccess] = useState(false)

  const url =
    urlProp ?? (typeof window !== 'undefined' ? window.location.href : '')
  const title =
    titleProp ?? (typeof document !== 'undefined' ? document.title : '')

  const handleClose = () => {
    setCopySuccess(false)
    onClose()
  }

  const handleCopyLink = () => {
    navigator.clipboard
      .writeText(url)
      .then(() => {
        setCopySuccess(true)
        setTimeout(() => setCopySuccess(false), 2000)
      })
      .catch((err) => {
        console.error('Failed to copy link:', err)
      })
  }

  const handleEmailShare = () => {
    const subject = encodeURIComponent(`Check out: ${title}`)
    const body = encodeURIComponent(
      `I thought you might be interested in this: ${url}`,
    )
    window.open(`mailto:?subject=${subject}&body=${body}`)
  }

  const handleXShare = () => {
    const text = encodeURIComponent(`Check out: ${title}`)
    window.open(
      `https://twitter.com/intent/tweet?text=${text}&url=${encodeURIComponent(url)}`,
    )
  }

  const handleFacebookShare = () => {
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
    )
  }

  const handleWhatsAppShare = () => {
    const text = encodeURIComponent(`Check out: ${title} - ${url}`)
    window.open(`https://wa.me/?text=${text}`)
  }

  if (!isOpen) {
    return null
  }

  const content = (
    <div className="a e a7 a8 a9 aa"
      data-testid="social-share-modal"
      style={{
        maxWidth: isMobile ? '90vw' : '29.5rem',
      }}
    >
      {/* Header */}
      <div className="a cf cg a2 f"
      >
        <Title.H5 style={{ margin: 0 }}>
          {translations.title}
        </Title.H5>
        <CloseButton onClick={handleClose} size="small" />
      </div>

      {/* Content */}
      <div className="a ch e bu cg i"
      >

        {/* Social Media Buttons */}
        <div className="k i" 
          style={{
            gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',}}
        >
          <SocialMediaButton icon={faEnvelope} label={translations.email} onClick={handleEmailShare} isMobile={isMobile} />
          <SocialMediaButton icon={faXTwitter} label={translations.x} onClick={handleXShare} isMobile={isMobile} />
          <SocialMediaButton icon={faFacebook} label={translations.facebook} onClick={handleFacebookShare} isMobile={isMobile} />
          <SocialMediaButton icon={faWhatsapp} label={translations.whatsapp} onClick={handleWhatsAppShare} isMobile={isMobile} />
        </div>

        {/* Copy Link Button */}
        <styled.button className="a f b a1 ci bo bx b4 cj al ck"
          onClick={handleCopyLink}
          style={{
            '&:hover': {
              backgroundColor: 'var(--shades-blue-100)',
            },
          }}
        >
          <div className="cl cm a f b au"
          >
            <FontAwesomeIcon icon={faLink} />
          </div>
          <span className="cn au aw"
          >
            {copySuccess ? translations.copiedLink : translations.copyLink}
          </span>
        </styled.button>
      </div>

      {/* Footer */}
      <div className="a cf cg co f"
      >
        <Button
          label={translations.close}
          onClick={handleClose}
          variant="primary"
          size="medium"
          style={{
            backgroundColor: 'var(--primary-red)',
            borderColor: 'var(--primary-red)',
          }}
        />
      </div>
    </div>
  )

  return (
    <ModalWrapper renderContainer={renderContainer}>{content}</ModalWrapper>
  )
}
